import { store } from '../../index'
import { reportError } from 'j-comps'
import config from '../../config'

export const setApi = async () => {
  try {
    // ;(function(document, url) {
    //   var script = document.createElement('script')
    //   script.src = url
    //   script.onload = function() {
    //     ;(async function() {
    //       if (window.CanvaButton) {
    //         const api = await window.CanvaButton.initialize({
    //           apiKey: config.vendor.apiKey,
    //         })
    //         // Use "api" object or save for later
    //         store.dispatch({
    //           type: 'SET_API',
    //           api,
    //         })
    //       }
    //     })()
    //   }
    //   document.body.appendChild(script)
    // })(document, 'https://sdk.canva.com/v2/beta/api.js')

    ;(function (document, url) {
      var script = document.createElement('script')
      script.src = url
      script.onload = function () {
        // API initialization

        ;(async function () {
          if (window.Canva && window.Canva.DesignButton) {
            const api = await window.Canva.DesignButton.initialize({
              apiKey: config.vendor.apiKey,
            })
            // Use "api" object or save for later
            store.dispatch({
              type: 'SET_API',
              api,
            })
          }
        })()
      }
      document.body.appendChild(script)
    })(document, 'https://sdk.canva.com/designbutton/v2/api.js')
  } catch (error) {
    const errorMessage = `Could not set ${config.vendor.name.titleCase} api`
    return reportError(store, errorMessage, error)
  }
}
